// extracted by mini-css-extract-plugin
export default {"commentFormPlaceholder":"_3F85g","commentFormWrapper":"_17gA3","commentForm":"_2CiGt"};